
        
        function render() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"75","height":"121","fill":"none"}},[_c('path',{attrs:{"fill":"#F84787","d":"M37.621 23c-6.328 0-11.25-4.922-11.25-11.25C26.371 5.656 31.528.5 37.621.5c6.094 0 11.25 5.156 11.25 11.25 0 6.328-5.156 11.25-11.25 11.25zM73.95 64.016c2.11 3.515.938 8.203-2.578 10.546-1.172.704-2.578.938-3.75.938-2.578 0-5.156-1.172-6.797-3.516L53.09 59.797 63.403 90.5h-9.375V113c0 4.219-3.516 7.5-7.5 7.5-4.22 0-7.5-3.281-7.5-7.5V90.5h-3.75V113c0 4.219-3.282 7.5-7.266 7.5-4.219 0-7.5-3.281-7.5-7.5V90.5h-9.375l10.312-30.703-7.5 12.187c-2.343 3.516-6.796 4.688-10.312 2.579C.12 72.219-1.051 67.53 1.059 64.016L15.59 41.28c3.984-6.796 11.25-10.78 18.984-10.78h5.86c7.734 0 15 3.984 18.984 10.781L73.95 64.016z"}})]);
        };
      

        module.exports = {
          
          render: render,
        };
      